<!-- <p>models works!</p> -->

<div class="pageContainer">
    <div class="layoutItem">
        <span style="font-size: large; font-weight: bolder;">Models</span>
        <span class="toolbar-spacer"></span>
        <div class="alignRow">
            <ejs-dropdownlist id="locationDropdown" #locationDropdown [dataSource]='dropdownLocations'
                placeholder="Select Location" [fields]="dropdownLocationFields"
                (change)="onQueryParameterChange('Location',$event)" [allowFiltering]="true"
                [(ngModel)]="this.filterQueryParams.Location" filterType="contains" [showClearButton]="true">
                <ng-template #itemTemplate let-data>
                    <div><span>{{data.Name}}</span></div>
                </ng-template>
            </ejs-dropdownlist>
        </div>
    </div>

    <div class="layoutItem">
        <ejs-tab id="element" [selectedItem]="selectedTabIndex"
            (selected)="onQueryParameterChange('SelectedTab',$event)">
            <e-tabitems>
                <e-tabitem #rulesTab>
                    <ng-template #headerText>
                        <span class="alignRow app-icon app-icon--models">
                            <mat-icon />&nbsp;Models
                        </span>
                    </ng-template>
                    <ng-template #content>
                        <div>
                            <ng-container *ngTemplateOutlet="ModelsTab"></ng-container>
                        </div>
                    </ng-template>
                </e-tabitem>
                <e-tabitem #rulesTab>
                    <ng-template #headerText>
                        <span class="alignRow app-icon app-icon--models">
                            <mat-icon />&nbsp;Assets With No Models
                        </span>
                    </ng-template>
                    <ng-template #content>
                        <div>
                            <ng-container *ngTemplateOutlet="NoModelsTab"></ng-container>
                        </div>
                    </ng-template>
                </e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>

</div>

<ng-template #ModelsTab>
    <ng-template #LoadingModels>
        <div class="waiting-container">
            <div class="item">
                <h2>Loading Models</h2>
            </div>
        </div>
    </ng-template>
    <div style="display: flex; margin-bottom: 0.5em;">
        <span class="toolbar-spacer"></span>
        <span style="font-style: italic;">{{getFilterMessage()}}</span>
    </div>

    <div class="search-div alignRow">
        <div class="search-box">
            <mat-form-field>
                <mat-label>Search for an Asset, Date, or User</mat-label>
                <input matInput (keyup)="onQueryParameterChange('ModelsFilter',$event)" placeholder="Search" #input>
            </mat-form-field>
        </div>
        <div class="location-dropdown">
            <mat-form-field>
                <mat-label>Model Type</mat-label>
                <mat-select #dropdownModelTypes [(value)]="selectedModelType"
                    (selectionChange)="onQueryParameterChange('ModelType',$event)">
                    <mat-option *ngFor="let type of modelTypes as ModelType" [value]="type">
                        {{ type.ModelName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="location-dropdown alignRow">
            <button mat-raised-button [color]="hasFilters ? 'primary' : undefined" class="filter-button"
                [matMenuTriggerFor]="filterMenuModels">
                <span>Filters</span>
                <mat-icon>tune</mat-icon>
            </button>
        </div>
    </div>
    <ng-container *ngIf="modelsReturned else LoadingModels">
        @if (selectedModelType && selectedModelType.ModelTypeID == 1) {
        <table mat-table matSort #tableModels #sortModels="matSort" [dataSource]="dataSourceModels"
            (matSortChange)="onQueryParameterChange('ModelsSortColumn',$event)"
            [matSortActive]="filterQueryParams.ModelsSortColumn || 'AssetName'"
            [matSortDirection]="filterQueryParams.ModelsSortDirection || 'asc'">
            <ng-container matColumnDef="AssetName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Asset</th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="goToModel(row)">
                    {{row.AssetName}} </td>
            </ng-container>
            <ng-container matColumnDef="CreatedAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="goToModel(row)">
                    {{convertEpoch(row.CreatedAt)}} </td>
            </ng-container>
            <ng-container matColumnDef="StartPoint">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Point</th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="goToModel(row)">
                    {{convertEpoch(row.StartPoint)}} </td>
            </ng-container>
            <ng-container matColumnDef="EndPoint">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>End Point</th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="goToModel(row)">
                    {{convertEpoch(row.EndPoint)}} </td>
            </ng-container>
            <ng-container matColumnDef="Type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="goToModel(row)">
                    {{row.IsAutomatic ? 'Automatic' : 'Manual'}} </td>
            </ng-container>
            <ng-container matColumnDef="CreatedBy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="goToModel(row)">
                    {{row.CreatedByUserSub != '' ? row.CreatedByUserSub : 'PRISMPdM'}} </td>
            </ng-container>
            <ng-container matColumnDef="MostRecent">
                <th mat-header-cell *matHeaderCellDef>Active</th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="goToModel(row)">
                    <mat-icon *ngIf="row.MostRecent" style="color: lightgreen;">check</mat-icon>
                    <mat-icon *ngIf="!row.MostRecent" style="color: salmon;">close</mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="Options">
                <th mat-header-cell *matHeaderCellDef>Options</th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row">
                    <button mat-icon-button [matMenuTriggerFor]="options" [matMenuTriggerData]="{ row: row }">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                </td>
                <mat-menu #options>
                    <ng-template matMenuContent let-row="row">
                        <div style="display: grid; grid-template-columns: 1fr; padding: 0.5em; gap: 4px 4px;">
                            <button mat-raised-button (click)="recreateModel(row)">
                                <span>Edit</span>
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button *ngIf="!row.MostRecent && !row.Disabled" mat-raised-button
                                (click)="activateModel(row)">
                                <span>Activate</span>
                                <mat-icon>check</mat-icon>
                            </button>
                            <button *ngIf="row.MostRecent && !row.Disabled" mat-raised-button
                                (click)="activateModel(row, true)">
                                <span>Deactivate</span>
                                <mat-icon>close</mat-icon>
                            </button>
                            <button *ngIf="!row.Disabled" mat-raised-button (click)="disableModel(row)">
                                <span>Delete</span>
                                <mat-icon style="color: salmon;">delete</mat-icon>
                            </button>
                            <!-- <button *ngIf="row.Disabled" mat-raised-button (click)="disableModel(row, true)">
                                <span>Enable</span>
                                <mat-icon style="color: lightgreen;">do_not_disturb_off</mat-icon>
                            </button> -->
                        </div>
                    </ng-template>
                </mat-menu>
            </ng-container>
            <ng-container matColumnDef="GoToAsset">
                <th mat-header-cell *matHeaderCellDef></th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="goToAsset(row)" class="app-icon--goto">
                    <mat-icon matTooltip="Go To Asset" />
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row class="table-row" [ngStyle]="{'color': row.Disabled ? 'grey' : ''}"
                *matRowDef="let row; columns: displayedColumns;">
            </tr>
            <tr class="mat-row" *matNoDataRow>
                <td *ngIf="input.value != ''" class="mat-cell" colspan="4">No Data Matching the Filter:
                    "{{input.value}}"</td>
                <td *ngIf="input.value == ''" class="mat-cell" colspan="4">No Data Matching the Filter</td>
            </tr>
        </table>
        }
        <mat-paginator #paginatorModels [pageSizeOptions]="[5, 10, 25, 100]"
            [pageSize]="filterQueryParams.ModelspageSize ?? 10" [pageIndex]="filterQueryParams.ModelspageIndex"
            (page)="onPageChange(paginatorModels, $event)" />
    </ng-container>
</ng-template>

<ng-template #NoModelsTab>
    <ng-template #LoadingAssets>
        <div class="waiting-container">
            <div class="item">
                <h2>Loading Assets</h2>
            </div>
        </div>
    </ng-template>
    <div style="display: flex; margin-bottom: 0.5em;">
        <span class="toolbar-spacer"></span>
        <span style="font-style: italic;">{{getLocationMessage()}}</span>
    </div>

    <div class="search-div alignRow">
        <div class="search-box">
            <mat-form-field>
                <mat-label>Search for an Asset</mat-label>
                <input matInput (keyup)="onQueryParameterChange('AssetsFilter',$event)" placeholder="" #input>
            </mat-form-field>
        </div>
    </div>

    <ng-container *ngIf="assetsReturned else LoadingAssets">
        <table mat-table matSort #tableAssets #sortAssets="matSort" [dataSource]="dataSourceAssets"
            (matSortChange)="onQueryParameterChange('AssetsSortColumn',$event)"
            [matSortActive]="filterQueryParams.AssetsSortColumn || 'Name'"
            [matSortDirection]="filterQueryParams.AssetsSortDirection || 'asc'">
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Asset Name</th>
                <td style="font-weight: bolder;" mat-cell *matCellDef="let row">
                    {{row.Name}} </td>
            </ng-container>
            <ng-container matColumnDef="Description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
                <td mat-cell *matCellDef="let row">
                    {{row.Description}} </td>
            </ng-container>

            <ng-container matColumnDef="HierarchyPath">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>HierarchyPath</th>
                <td mat-cell *matCellDef="let row">
                    {{row.HierarchyPath}} </td>
            </ng-container>

            <ng-container matColumnDef="Buttons">
                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell *matCellDef="let row">
                    <button mat-raised-button (click)="ManageModels(row)">
                        <!-- <mat-icon>more_horiz</mat-icon> -->
                        <span>Manage</span>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="GoToAsset">
                <th mat-header-cell *matHeaderCellDef></th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="goToAsset(row)" class="app-icon--goto">
                    <mat-icon matTooltip="Go To Asset" />
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="filteredAssetColumns"></tr>
            <tr mat-row class="table-row" *matRowDef="let row; columns: filteredAssetColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td *ngIf="input.value != ''" class="mat-cell" colspan="6">No Data Matching the Filter:
                    "{{input.value}}"</td>
                <td *ngIf="input.value == ''" class="mat-cell" colspan="6">No Data Matching the Filter</td>
            </tr>
        </table>
        <mat-paginator #paginatorAssets [pageSizeOptions]="[10, 15, 20, 25, 50]"
            [pageSize]="filterQueryParams.AssetspageSize ?? 10" [pageIndex]="filterQueryParams.AssetspageIndex"
            (page)="onPageChange(paginatorAssets, $event)" aria-label="Select page of Assets"></mat-paginator>
    </ng-container>
</ng-template>


<mat-menu #filterMenuModels>
    <div class="filter-switch-div">
        <div class="enabled-switch-div" [ngClass]="{'disabled-checkbox': filterQueryParams.Manual}">
            <span style="margin-right: 0.2em;">Automatic Only</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="setFilterOption('automatic only', $event.checked)" [disabled]="filterQueryParams.Manual"
            [checked]="filterQueryParams.Automatic"></mat-checkbox>

        <div class="enabled-switch-div" [ngClass]="{'disabled-checkbox': filterQueryParams.Automatic}">
            <span style="margin-right: 0.2em;">Manual Only</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="setFilterOption('manual only', $event.checked)" [disabled]="filterQueryParams.Automatic"
            [checked]="filterQueryParams.Manual"></mat-checkbox>

        <div class="active-switch-div" [ngClass]="{'disabled-checkbox': filterQueryParams.Disabled}">
            <span style="margin-right: 0.2em;">Active Only</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="setFilterOption('most recent', $event.checked)" [checked]="filterQueryParams.Active"
            [disabled]="filterQueryParams.Disabled"></mat-checkbox>

        <!-- <div class="active-switch-div"
            [ngClass]="{'disabled-checkbox': filterData.Enabled || filterData.MostRecent}">
            <span style="margin-right: 0.2em;">Disabled Only</span>
            </div>
            <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="setFilterOption('disabled', $event.checked)"
            [disabled]="filterData.Enabled || filterData.MostRecent" [checked]="filterData.Disabled"></mat-checkbox>

            <div class="active-switch-div" [ngClass]="{'disabled-checkbox': filterData.Disabled}">
            <span style="margin-right: 0.2em;">Enabled Only</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
        (change)="setFilterOption('enabled', $event.checked)"
        [checked]="filterData.Enabled || filterData.MostRecent"
        [disabled]="filterData.Disabled"></mat-checkbox> -->
    </div>
</mat-menu>